// src/pages/UserList.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { fetchAllUsers } from '../services/api'; 

function UserList() {
  const [users, setUsers] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchAllUsers()
      .then(setUsers)
      .catch(err => {
        console.error('Failed to fetch users:', err);
        setError('Failed to fetch users');
      });
  }, []);

  if (error) {
    return <div className="alert alert-danger" role="alert">{error}</div>;
  }

  if (users.length === 0) {
    return <div>Loading users...</div>;
  }

  return (
    <div className="container mt-3">
      <h1>User List</h1>
      <table className="table">
        <thead>
          <tr>
            <th>NetID</th>
            <th>Name</th>
            <th>Department</th>
            <th>Details</th>
          </tr>
        </thead>
        <tbody>
          {users.map(user => (
            <tr key={user.netId}>
              <td>{user.netId}</td>
              <td>{user.firstName} {user.lastName}</td>
              <td>{user.department}</td>
              <td><Link to={`/user/${user.netId}`}>View Details</Link></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default UserList;
